import { render, staticRenderFns } from "./SemVinculoAUmClube.vue?vue&type=template&id=c8b406ca"
import script from "./SemVinculoAUmClube.vue?vue&type=script&lang=ts"
export * from "./SemVinculoAUmClube.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports